import React from "react";
import { getUserID } from "../../Utility/service";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Checkbox, Dropdown, Menu, Pagination } from "antd";
import {
  IoChatbubbleEllipsesOutline,
  IoGitCompareOutline,
} from "react-icons/io5";
import { BsRobot, BsThreeDotsVertical } from "react-icons/bs";
import "./Assistant.css";
//libraries
import {
  Button,
  Space,
  Table,
  Tag,
  Modal,
  Tooltip,
  Switch,
  message,
  Spin,
} from "antd";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import axios from "axios";
import {
  fetchPublicAssistant,
  getFavoriteCount,
  deleteSinglePublicAssistant,
  addOrRemoveFeaturedAssistant,
} from "../../api/publicAssistant";
import {
  showDeletePublicConfirm,
  handleCheckboxChange,
} from "../../Utility/showModalHelper";
import DebouncedSearchInput from "../../Pages/SuperAdmin/Organizations/DebouncedSearchInput";
import { CustomSpinner } from "../common/CustomSpinner";
import { personalizeAssistant } from "../../api/personalizeAssistant";
import { LuCopyPlus } from "react-icons/lu";
import { CopyOutlined, SyncOutlined } from "@ant-design/icons";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { axiosSecureInstance } from "../../api/axios";
import { BiSolidLock, BiSolidLockOpen } from "react-icons/bi";
import { RiPushpinLine, RiUnpinLine } from "react-icons/ri";
import { generateEmbedCode } from "../../constants/Api_constants";
import ProfileHeader from "../Proflie/ProfileHeader";

const { confirm } = Modal;

const PublicAssistantList = ({ data }) => {
  const navigate = useNavigate();
  const {
    adminUserAssistants,
    loader,
    handleDeleteAssistant,
    handleUpdateAssistant,
    showEditModalHandler,
    handleFetchUserCreatedAssistants,
    handlePublicAssistantAdd,
    getFavoriteAssistant,
    handleDeletePublicAssistant,
    publicAssistant,
    setPublicAssistant,
    setIsLoading,
    isLoading,
    setLoadMyAssistants,
    updateLoader,
  } = data;

  const [totalCount, setTotalCount] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [isAssistantSyncing, setIsAssistantSyncing] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

//   useEffect(() => {
//     // Fetch public assistants
//     const page = 1;
//     const searchQuery = "";

//     fetchPublicAssistant(
//       publicAssistant,
//       setPublicAssistant,
//       setIsLoading,
//       setTotalCount,
//       page,
//       searchQuery
//     );
//   }, []);
  useEffect(() => {
    // Fetch public assistants
    fetchPublicAssistant(
      publicAssistant,
      setPublicAssistant,
      setIsLoading,
      setTotalCount,
      currentPage,
      searchQuery,
      pageSize
    );
  }, [searchQuery, currentPage, pageSize]);

  const query =
    typeof searchQuery === "string" ? searchQuery?.toLowerCase() : "";

  // Open selected card in a new page
  const openAssistantNewPage = (assistantId, name) => {
    navigate(`/agents/${assistantId}`);
  };

  const navigateToCustomizationPage = (assistantName, assistantId) => {
    navigate(`/customize-embed-code/${assistantId}`);
  };

  const createActionMenu = (record) => {
    return (
      <Menu>
        {
          <Menu.Item key="chat">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={() =>
                openAssistantNewPage(record?.assistant_id, record?.name)
              }
            >
              <IoChatbubbleEllipsesOutline /> Chat with Agent
            </span>
          </Menu.Item>
        }
        {
          <Menu.Item key="personalize">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={async () => {
                await personalizeAssistant(record?.assistant_id);
                setLoadMyAssistants(true);
              }}
            >
              <LuCopyPlus /> Personalize Agent
            </span>
          </Menu.Item>
        }

        {
          <Menu.Item key="feature">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={() =>
                handleCheckboxChange(
                  record,
                  !record?.is_featured,
                  publicAssistant,
                  setPublicAssistant,
                  handleUpdateAssistant
                )
              }
            >
              {record?.is_featured ? <RiPushpinLine /> : <RiUnpinLine />}
              {record?.is_featured ? "Unmark as featured" : "Mark as Featured"}
            </span>
          </Menu.Item>
        }
        {
          <Menu.Item key="delete" danger>
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={async () =>
                await showDeletePublicConfirm(
                  record,
                  handleDeletePublicAssistant,
                  handleUpdateAssistant,
                  publicAssistant,
                  setPublicAssistant
                )
              }
            >
              <AiOutlineDelete /> Delete
            </span>
          </Menu.Item>
        }
      </Menu>
    );
  };

  const columns = [
    {
      title: "Agent",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (_, { name, image_url }) => (
        <Space size="middle" className="d-flex align-items-center">
          <div className="assistantImageDiv">
            {image_url ? (
              <img src={image_url} className="customImage" alt="avatar" />
            ) : (
              <BsRobot className="customImage" />
            )}
          </div>
          <div className="ms-2 text-start">{name}</div>
        </Space>
      ),
    },
    {
      title: "Created By",
      dataIndex: "Created By",
      key: "created_by",
      align: "center",
      render: (_, record) => (
        <span className="text-left">{record.userInfo}</span>
      ),
    },

    {
      title: "Favorite Count",
      dataIndex: "Count",
      key: "Count",
      align: "center",
      render: (_, record) => <span className="text-left">{record.count}</span>,
    },
    {
      title: "Action",
      key: "action",
      width: "10%",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown overlay={createActionMenu(record)} trigger={["click"]}>
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                <BsThreeDotsVertical />
              </Space>
            </a>
          </Dropdown>
          {/* <Tooltip title="Chat with Agent">
                        <Button onClick={() => openAssistantNewPage(record?.assistant_id, record?.name)}><IoChatbubbleEllipsesOutline /></Button>
                    </Tooltip>

                    <Tooltip title="Delete">
                        <Button

                            onClick={async () => await showDeletePublicConfirm(record, handleDeletePublicAssistant, handleUpdateAssistant, publicAssistant, setPublicAssistant)}
                            danger
                            icon={<AiOutlineDelete />}
                            loading={
                                loader.ASSISTANT_DELETING === record._id
                            }
                            disabled={loader.ASSISTANT_LOADING ||
                                loader.ASSISTANT_DELETING
                            }
                        />
                    </Tooltip>

                    <Tooltip title="Personalize Agent">
                        <Button onClick={async () => 
                            {await personalizeAssistant(record?.assistant_id);
                                setLoadMyAssistants(true);

                            
                            }
                        }><LuCopyPlus /></Button>
                    </Tooltip>
                    <Tooltip title="Add to Feature">
                        <Checkbox
                            checked={record?.is_featured}
                            onChange={(e) => handleCheckboxChange(record, e.target.checked, publicAssistant, setPublicAssistant, handleUpdateAssistant)} />
                    </Tooltip> */}
        </Space>
      ),
    },
  ];
  const handleSyncButton = async () => {
    setIsAssistantSyncing(true);
    setIsLoading(true);
    const isSyncSuccess = await axiosSecureInstance.get(
      "api/assistants/public/sync"
    );
    message.success(isSyncSuccess.data.message);
    setIsLoading(false);
    setIsAssistantSyncing(false);
  };

  return (
    <>
    <div className="mb-1">
      <ProfileHeader
        title="Public Agents"
        subHeading="Explore publicly available AI agents."
      />

      <div className="searchbox-container">
        <div className="searchbox-wrapper">
          <DebouncedSearchInput
            data={{
              search: searchQuery,
              setSearch: setSearchQuery,
              placeholder: "Search Agent",
            }}
          />
        </div>

        <Pagination
          current={currentPage}
          pageSize={pageSize}
          total={totalCount}
          showSizeChanger={true}
          onShowSizeChange={(current, size) => {
            setPageSize(size);
            setCurrentPage(1);
          }}
          onChange={(page) => setCurrentPage(page)}
          showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
        />
      </div>
    </div>

    <Table
      loading={isLoading}
      columns={columns}
      dataSource={publicAssistant}
      scroll={{ y: "50vh" }}
      className={`${(isLoading || publicAssistant?.length === 0) ? "mt-3" : ""}`}
      pagination={false}
    />
  </>
  );
  
};

export default PublicAssistantList;
